import type { Strings } from './strings.js';

export const de: Strings = {
  languageName: 'Deutsch',
  welcome: 'Willkommen',
  chooseReason: 'Wie können wir Ihnen helfen?',
  back: 'Zurück',
  cancel: 'Abbrechen',
  next: 'Weiter',
  submit: 'Anmeldung absenden',
  submitting: 'Wird gesendet',
  yourDetails: 'Ihre Angaben',
  optional: 'optional',
  required: 'Pflichtfeld',
  requiredHint: 'Bitte füllen Sie die markierten Felder aus.',
  fieldRequired: 'Bitte ergänzen Sie diese Angabe.',
  fieldInvalid: 'Bitte prüfen Sie diese Angabe.',
  pleaseSelect: 'Bitte wählen',
  search: 'Suchen',
  noResults: 'Kein Treffer',
  noOptions: 'Hier steht zurzeit keine Auswahl zur Verfügung. Bitte wenden Sie sich an den Empfang.',
  stepReason: 'Besuchsgrund',
  stepDetails: 'Angaben',
  stepDone: 'Fertig',
  thankYou: 'Vielen Dank!',
  submitted: 'Ihre Anmeldung wurde übermittelt.',
  waitHint: 'Bitte nehmen Sie Platz. Sie werden in Kürze aufgerufen.',
  scanFormHint: 'Scannen Sie den Code mit Ihrem Handy, um das Formular mitzunehmen.',
  ticketNumber: 'Ihre Wartenummer lautet',
  queuedTitle: 'Vielen Dank!',
  queuedHint: 'Ihre Anmeldung wurde gespeichert und wird automatisch übermittelt. Bitte nehmen Sie Platz.',
  errorTitle: 'Das hat leider nicht geklappt',
  errorHint: 'Bitte versuchen Sie es erneut oder wenden Sie sich an den Empfang.',
  tryAgain: 'Erneut versuchen',
  startOver: 'Neu beginnen',
  closedTitle: 'Unsere Verwaltung ist derzeit geschlossen',
  closedHint: 'Sie können sich trotzdem anmelden – wir melden uns am nächsten Öffnungstag.',
  closedCallUs: 'Telefonisch erreichbar unter',
  continueAnyway: 'Trotzdem anmelden',
  appointmentQuestion: 'Haben Sie einen Termin?',
  appointmentYes: 'Ja, ich habe einen Termin',
  appointmentNo: 'Nein, ich habe keinen Termin',
  visitingWhom: 'Wen möchten Sie besuchen?',
  privacyTitle: 'Datenschutz',
  privacyAccept: 'Ich habe die Datenschutzhinweise gelesen.',
  privacyRequired: 'Bitte bestätigen Sie die Datenschutzhinweise.',
  offline: 'Offline',
  offlineHint: 'Keine Verbindung – Anmeldungen werden gespeichert und später übermittelt.',
  pendingCount: 'gespeicherte Anmeldung(en)',
  idleWarning: 'Ihre Eingaben werden gleich verworfen.',
  pairTitle: 'Tablet verbinden',
  pairHint: 'Bitte geben Sie den Kopplungscode aus der Verwaltung ein.',
  pairPlaceholder: 'ABCD-1234',
  pairButton: 'Verbinden',
  pairError: 'Der Code ist ungültig oder abgelaufen.',
  pairSuccess: 'Tablet verbunden',
  loading: 'Wird geladen',
  notConfigured: 'Keine Besuchsarten eingerichtet',
  notConfiguredHint: 'Bitte wenden Sie sich an den Empfang.',
  adminLink: 'Verwaltung',
  pairCodeHint:
    'Der Code wird in der Verwaltung unter „Standorte und Tablets“ erzeugt und ist zeitlich begrenzt gültig.',
  setupTitle: 'Noch nicht eingerichtet',
  setupText:
    'Dieses System wurde noch nicht eingerichtet. Der Einrichtungsassistent legt Administrator, Mandant, Standort und das erste Tablet an.',
  setupButton: 'Einrichtung starten',
  setupAfter: 'Danach erscheint hier automatisch die Eingabe des Kopplungscodes.',
};
